import { Card } from './Card'
import profileCheck from '@/assets/icons/profile-check.svg'
import badge from '@/assets/icons/badge.svg'
import measure from '@/assets/icons/measure.svg'
import file from '@/assets/icons/file.svg'
import thumbsUp from '@/assets/icons/thumbs-up.svg'

const features = [
  {
    title: 'Client-Centered Design',
    imageUrl: profileCheck,
    description:
      'We prioritize your needs, ensuring every space we design aligns with your vision and lifestyle.',
  },

  {
    title: 'Experience and Expertise',
    imageUrl: badge,
    description:
      'With years of experience, we deliver high-quality interiors that stand the test of time.',
  },
  {
    title: 'Tailored Solutions',
    imageUrl: measure,
    description:
      'Our designs are customized to fit your specific requirements, ensuring functionality and style.',
  },
  {
    title: 'Transparent Process',
    imageUrl: file,
    description:
      'We maintain clear communication and transparency throughout the project, keeping you informed at every step.',
  },
  {
    title: 'Satisfaction Guaranteed',
    imageUrl: thumbsUp,
    description:
      "Your satisfaction is our top priority. We work until you're completely happy with the results.",
  },
]
export const Cards = () => {
  return (
    <div className="flex flex-col gap-x-[24px] gap-y-[15px] md:flex-row md:flex-wrap md:gap-y-[26px]">
      {features.map((feature, index) => (
        <Card {...feature} key={index} />
      ))}
    </div>
  )
}
